import { z } from 'zod';

export const tpOutletSchema = z.object({
  text: z.string().min(1),
  portCount: z.number().min(0).int(),
  location: z.string(),
});

export type TpOutletSchema = z.infer<typeof tpOutletSchema>;
